import { useContextSelector } from "use-context-selector"
import { GlobalModalContext } from "./GlobalModalContextProvider.react"

export const useGlobalModal = () => ({
  openModal: useContextSelector(GlobalModalContext, ctx => ctx.openModal),
  closeModal: useContextSelector(GlobalModalContext, ctx => ctx.closeModal),
  onPrevious: useContextSelector(GlobalModalContext, ctx => ctx.onPrevious),
})
